import ListSkills from './ListSkills';
import { SKILLS } from "../../data/resumeData";

function Skills() {
    return (
      <section className="skills fade-in new-page-section">
        <h2>Skills</h2>
        <div id="SkillsCard" className="card">
            <ListSkills items={SKILLS} />
        </div>
      </section>
    );
  }
  
  export default Skills;